var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.93787C5.38144 1.93787 2.4375 4.88177 2.4375 8.50028C2.4375 12.119 5.38144 15.0629 9 15.0629C12.6186 15.0629 15.5625 12.119 15.5625 8.50028C15.5625 4.88177 12.6186 1.93787 9 1.93787ZM8.99991 16.7504C4.45095 16.7504 0.75 13.0494 0.75 8.50028C0.75 3.95132 4.45095 0.250366 8.99991 0.250366C13.5489 0.250366 17.2498 3.95132 17.2498 8.50028C17.2498 13.0494 13.5489 16.7504 8.99991 16.7504Z",
    fill: "#003C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.694 7.96631C12.1751 8.25836 12.1751 8.95644 11.694 9.24849L7.88919 11.5586C7.38938 11.862 6.74996 11.5022 6.74996 10.9175L6.74996 6.29731C6.74996 5.71259 7.38937 5.35276 7.88919 5.65622L11.694 7.96631Z",
    fill: "#003C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayIcon);
export default __webpack_public_path__ + "static/media/replayIcon.4b7946c4e17670da1bdbff5ef46e0501.svg";
export { ForwardRef as ReactComponent };